import { createSlice } from '@reduxjs/toolkit'
import { fetchAllPlayers } from 'redux-thunk/thunk/Players/players'

const initialState = {
  allPlayers: null
}

const playerSlice = createSlice({
  name: 'playerSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPlayers.fulfilled, (state, action) => {
        return {
          ...state,
          allPlayers: action.payload
        }
      })
  }
})

export default playerSlice.reducer
